import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-burgundy-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo */}
          <div className="flex flex-col items-center space-y-4">
            <img
              src="/assets/images/logo_ups_invertido.png"
              alt="Logo UPS"
              className="w-32 h-auto"
            />
            <img
              src="https://granacertification.org/wp-content/uploads/2022/07/logo-header.jpg"
              alt="Logo GRANA"
              className="w-32 h-auto rounded-lg border border-burgundy-200 bg-white"
              style={{marginTop: '8px'}}
            />
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-burgundy-200 hover:text-white transition-colors">Inicio</Link></li>
              <li><Link to="/acreditacion" className="text-burgundy-200 hover:text-white transition-colors">Acreditación</Link></li>
              <li><Link to="/pilares" className="text-burgundy-200 hover:text-white transition-colors">Pilares del Modelo</Link></li>
              <li><Link to="/recursos" className="text-burgundy-200 hover:text-white transition-colors">Recursos</Link></li>
              <li><Link to="/noticias" className="text-burgundy-200 hover:text-white transition-colors">Noticias</Link></li>
              <li><a href="https://sievas.granacertification.org/" target="_blank" rel="noopener noreferrer" className="text-burgundy-200 hover:text-white transition-colors">SIEVAS</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contacto</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <Mail className="h-4 w-4 text-burgundy-300" />
                <span className="text-burgundy-200">
                  <a href="mailto:dvallin@certification-grana.org" className="hover:burgundy">dvallin@certification-grana.org</a>
                  <br />
                  <a href="mailto:accreditationgrana@gmail.com" className="hover:burgundy">accreditationgrana@gmail.com</a>
                  <br />
                  <a href="mailto:donatovallingonzalez@gmail.com" className="hover:burgundy">donatovallingonzalez@gmail.com</a>
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="h-4 w-4 text-burgundy-300" />
                <span className="text-burgundy-200">USA: +1 (650) 690 2130
                  <br />México: +52 (317) 385 1203
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <MapPin className="h-4 w-4 text-burgundy-300" />
                <span className="text-burgundy-200">2350 Alamo Ave. Suite 301 
                  <br />Albuquerque, NM, EEUU, 87106
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-burgundy-800 mt-8 pt-8 text-center">
          <p className="text-burgundy-200">
            © 2025 Universidades Promotoras de la Salud - GRANA. Todos los derechos reservados. <br /> Diseño y desarrollo: <a href="https://programacioninteligente.com/" target='_blank' className="hover:burgundy"><i>Programación Inteligente.com</i></a>
          </p>
        </div>
      </div>
    </footer>
  );
};